export default __webpack_public_path__ + "static/media/finance-gif4.09b06833.gif";